import Service, { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { Language } from '@square/dashboard-protos/models/squareup/common/languages';
import { StartSessionRequest } from '@square/dashboard-protos/models/squareup/jedi/service';
import { feature } from '@square/ember-features/macros';
import JediService from '@banking/ui/services/jedi/jedi';

// eslint-disable-next-line ember/no-classic-classes
export default Service.extend({
  shouldOverrideJediLocale: feature('disputes/should_override_jedi_locale'),
  userInfo: service(),
  makeStartSessionRequest({
    anonymousToken,
    unitToken
  }) {
    const request = StartSessionRequest.create({
      anonymousToken,
      unitToken,
      countryCode: this.shouldOverrideJediLocale ? Country.US : Country[this.userInfo.countryCode],
      languageCode: this.shouldOverrideJediLocale ? Language.EN : Language[this.userInfo.browserLanguage.split('-').firstObject.toUpperCase()],
      client: 'dashboard'
    });
    return JediService.startSession(request);
  }
});